export default {
    bodyPrimary: {
        color: 'neutral_8',
        fontSize: 3,
        lineHeight: 'normal',
    },
    bodySecondary: {
        color: 'neutral_8',
        fontSize: 2,
        lineHeight: 'normal',
    },
    captionPrimary: {
        color: 'neutral_6',
        fontSize: 2,
        lineHeight: 'small',
    },
    captionSecondary: {
        color: 'neutral_6',
        fontSize: 0,
        lineHeight: 'tight',
    },
    metadata: {
        color: 'neutral_7',
        fontSize: 0,
        lineHeight: 'tight',
    },
    code: {
        color: 'neutral_8',
        fontFamily: 'IBM Plex Mono',
        fontSize: 1,
        lineHeight: 'normal',
    },
    inverse: {
        color: 'neutral_0',
        fontSize: 3,
        lineHeight: 'normal',
    },
};
